import React, { Component } from "react";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import AuthService from "../../../../services/login/auth.service";
import PagoAporteService from "../../../../services/pagos/PagoAporteService";
import { splitImporte } from "../../../generico/utils/FormatoInput";
import { trackPromise } from "react-promise-tracker";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faFilePdf} from "@fortawesome/free-solid-svg-icons";

export default class AportePaso3 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.newTransfer = this.newTransfer.bind(this);
  }

  getInitialState = () => ({
    listaFactura: false,
  });
  newTransfer() {
    this.props.returnDataPaso3();
    this.firstStep.click();
  }
  componentDidMount() {}

  descargar = async () => {
    var listaFactura = [];
    await trackPromise(
      PagoAporteService.descagarComponente("Pago de Aporte", this.props.nroOperacion, AuthService.getSocio().numeroSocio.trim() +" - "+AuthService.getSocio().nombreCompleto, this.props.ctaFullData.idAhorro +" - "+this.props.ctaFullData.descripcion, this.props.moneda, this.props.importe)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

    this.setState({ listaFactura: true });
   // return listaFactura;
  };
  render() {
   // console.log(this.state.listaFactura)
    if (this.props.currentStep === 3 && !this.state.listaFactura) {
      mensajeExito("El Pago se Realizó Correctamente");
    }
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Pago</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-md-7" style={{ textAlign: "end" }}>
            <p className="nro-operacion">
              Número de Operación: {this.props.nroOperacion}
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-7">
            <h6 className="item-vef" style={{ margin: 0 }}>
              Socio: {AuthService.getSocio().numeroSocio.trim()} -{" "}
              {AuthService.getSocio().nombreCompleto}
            </h6>
            <p className="item-vef" style={{ marginBottom: 0 }}>
              Cuenta: {this.props.ctaFullData.idAhorro}-
              {this.props.ctaFullData.descripcion}
            </p>
            <p className="item-vef" >Moneda: {this.props.moneda}.</p>
            <p className="item-vef">Fecha de Operación: { (new Date()).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) }</p>
            <h6 className="item-vef">
              Total a Pagar: {this.props.importe} {this.props.moneda}.
            </h6>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-lg-8 col-md-6"></div>
          <div className="col-lg-2 col-md-3">
          <button
            onClick={this.newTransfer}
            type="button"
            className="btn btn-cu-quintary btn-consulta"
          >
          <FontAwesomeIcon icon={faArrowLeft} />  Ir al Inicio
          </button>
          </div>
          <div className="col-lg-2 col-md-3">
          <button className="btn btn-cu-primary" onClick={this.descargar}> <FontAwesomeIcon icon={faFilePdf} /> Descargar Comprobante</button>
          <button
            hidden
            ref={(a) => (this.firstStep = a)}
            onClick={this.props.firstStep}
          ></button>
          </div>
        </div>
      </div>
    );
  }
}
